/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
// import draggable from 'vuedraggable'
import {
  gettHeaderByType,
  settHeaderByType,
  getMarketClue,
  getMarketClueSourceList,
  setMarketClueStatusReceiver,
  setMarketClueStatusInvalid,
  setMarketClueUser,
  getMarketClueExportData,
  getMarketChannelType,
  getMarketCooperationPrevLevel,
  getMarketChannelNameByTypeId,
  getMarketHighSchoolBranchCenterList, getDeparmentList, setMarketClueFollow
} from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { UserModule } from '@/store/modules/user'
import realTimeSokcet from '@/utils/socket.io'
import { delNullProperty } from '@/utils/index'
import qrcodeVue from 'qrcode.vue'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import CommonData from "@/utils/commonData";

@Component({
  components: { qrcodeVue , MoreUsersFilter}
})
export default class MarketClues extends Vue {
  // ------ 变量 ------
  buttonShow = menuBtn // 方法：按钮权限验证
  tableData = []
  page = 1
  pageSize = 20
  total = 0
  aloneDialogTable = [] // 操作某条单独数据时弹框中的表格数据
  aloneIssueDialog = false // 单独下发
  editAloneIssueDialog = false // 单独修改下发人
  aloneInvaildId: number // 单独标为无效的数据id
  aloneInvaildDialog = false // 单独标为无效弹框
  issueDialogShow = false // 批量下发
  takeBackClueID: number // 收回线索id
  takeBackClueDialog = false // 收回线索弹框
  markInvalidDialogShow = false // 标为无效
  editUpPersonDialogShow = false // 修改下发人
  editSourceDialogShow = false // 修改来源
  editDutyDialogShow = false // 修改负责人
  checkTableList: any[] = [] // 选中的表格数据 --- 详细数据
  filterClueName = '' // 筛选线索名称
  filterSourceName = '' // 筛选具体来源名称
  filterSourceNameList = [] // 具体来源名称数组
  filterCreateTime: Date[] | null = null // 筛选线索创建时间
  filterWechat = '' // 筛选学生微信
  filterStatus: number[] = [] // 筛选线索状态
  filterDuty = [] // 筛选市场负责人
  filterCreatePeople = [] // 筛选创建人
  // fiterCustomerName = '' // 筛选客户名称
  filterButtPeople: string[] = [] // 筛选下发对接人
  filterContract: number | string = '' // 筛选客户签约状态
  filterLssueTime: Date[] | null = null // 筛选下发时间
  filterSource: string[] = [] // 筛选来源
  filterEduTemandList: string[] = []
  filterLevel2Scourse = '' // 二级来源
  filterLevel2DepartmentId: number = null // 下发对接人二级部门
  filterIntentionality = '' // 客户意向度
  customerUserRealName = '' // 筛选客户名称
  filterReceiverLevel2Department = '' // 负责人所属二级部门
  level2DepartmentList = [
    {name: '北京咨询部', id: 1047},
    {name: '上海咨询部', id: 1048},
    {name: '深圳咨询部', id: 1049},
    {name: '成都咨询部', id: 1065},
    {name: '广州咨询部', id: 1143},
    {name: '苏州咨询部', id: 1146}
  ]
  gradeList = CommonData.gradeList
  intentionalityList =  [
    {label:'A',value:'A',interpretation:'（7天内签约）'},
    {label:'B',value:'B',interpretation:'（15天内签约）'},
    {label:'C',value:'C',interpretation:'（30天内签约）'},
    {label:'D',value:'D',interpretation:'（90天内签约）'},
    {label:'E',value:'E',interpretation:'（长期跟进）'},
    {label:'F',value:'F',interpretation:'（流失并调入公海）'},
    {label:'已签约',value:'已签约',interpretation:''},
  ]
  eduTemandOptions = CommonData.eduTemandOptions
  filterGrade: string[] = [] // 筛选学生年级
  filterDirection = '' // 筛选咨询专业方向
  directionList = ['理工科', '传媒艺术电影', '人文社科', '金融商科', '计算机', '其他'] // 咨询专业方向分类
  filterDegree: string[] = [] // 筛选意向度
  marketTableHead: any[] = [] // 表头顺序列表
  draggableList: any[] = [] // 调整的表头顺序
  loading = false // 加载动画
  sourceloading = false // 加载动画
  tableHeadPopoverShow = false // 调整表头顺序的弹框是否可见
  // tableKey: number | null = null // el-table  key
  filterPopoverShow = false // 筛选的弹框是否出现
  receiverUser = '' // 修改后的下发对接人
  editSourceType: number | string = '' // 重新选择来源
  editSource = '' // 来源名称
  filterShow = false
  exportDialogShow = false // 导出loading框
  sourceChildList = [] // 市场渠道子节点数组
  cooperativePartnerList = [] // 合作伙伴数据
  branchedPassageList = [] // 分管数据
  collegesList = [] // 高校数据
  // 市场渠道树形结构懒加载之后的数据结构
  cascaderProps = {
    value: 'id',
    label: 'name',
    expandTrigger: 'click',
    lazy: true,
    lazyLoad: this.cascaderLazyload
  }
  editSourceCascader: number[] = [] // 市场渠道选中的节点数组
  socket = null
  buttonDisabled = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  qocodeDialog = false

  showNav = false
  showButton = false
  innerWidth = 0
  sourcePage = 1
  sourceLimit = 20
  source = ""
  sourceNameList = []

  marketLevelPage = 1
  marketLevelSize = 20
  cooperativePartnerName = ''
  marketLevelloading = false
  disBtn = false
  departmentIdList = []
  deparmentList: any = [] // 部门列表
  checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
  timer = null
  // isReadonly = false
  draggableListChange = []
  vdaH = 0 //屏幕高度
  popHeight = 0
  filterLevel = ''

  filterAttendSchool = '' // 学校筛选
  isPublic = '' // 是否
  filtersignAt: Date[] | null = null  // 签约时间
  stageList = [
    '一句话不说',
    '回复画像后消失',
    '报价消失/费用劝退',
    '时间不着急',
    '其他原因'
  ]
  followStage = ''
  followContent = ''
  editFollowDialogShow = false
  followStatus = '' // 回访状态
  remark = '' // 备注
  cause = '' // 无效原因
  causeList = ['拉黑', '明确不需要']
  reason = ''
  stage = '' // 卡点阶段
  isShowStage = false //批量跟进是否展示卡点阶段
  isFromPractice = ''
  phone = ''
  equipment = ''

  // ------ 计算属性 ------
 
  get batchIssueButton() {
    return this.checkTableList.every(item => item.status === 0 || item.status === 3)
  }
  get batchInvaildButton() {
    return this.checkTableList.every(item => item.status === 0 || item.status === 3)
  }
  get batchEditIssueButton() {
    return this.checkTableList.every(item => item.status === 2)
  }
  get QrcodeUrl() {
    let str = window.location.origin + '/applicationForms'

    str += '?isH5=1'
    str += '&userId=' + this.userId
    str += '&from=market'
    return str
  }

  get userId() {
    return UserModule.userId
  }

  // ------ 生命周期 ------
  created() {
    this.getMarketClueHeader()
    // if(this.userId) this.initSocket()
    if(this.userId) this.getTableData()
    this.getMarketClueSourceList()
    this.getDeparment()
    const h = document.documentElement.clientHeight || document.body.clientHeight;
    this.vdaH = h - 260 ;
    this.popHeight = this.vdaH
  }

  // ------ 方法 -------


  handleBatchVisit() {
    // 批量跟进时如果选择的状态存在不一样的要提醒，不允许批量回访
    const arr = []
    this.checkTableList.forEach(item => {
      if (item.status == 2) { // 如果为已下发
        // 是否全部为已下发
        arr.push(item)
      }
    })
    if(arr.length == this.checkTableList.length){
      this.isShowStage = true
    }
    if ((arr.length > 0) && (arr.length !== this.checkTableList.length)) { //包含且不是全部为已下发
      this.$message.error('存在不一样的状态，不允许批量回访')
      return;
    }
    this.editFollowDialogShow = true
  }

  // 回访
  clickFollowUp(row) {
    const win = window.open(`${window.location.origin + this.$route.matched[0].path}/marketFollowUp?id=${row.id}&name=${row.name}&status=${row.status}`, '_blank')
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }

  clickFollowRecord(row){
    const win = window.open(`${window.location.origin + this.$route.matched[0].path}/marketFollowRecord?id=${row.id}&name=${row.name}`, '_blank')
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }


  closeFollowDialogVisible(){
    this.editFollowDialogShow = false
    this.followStage = ''
    this.followContent = ''
  }

  async confirmFollowDialogVisible() {
    const arr = this.checkTableList.map(item => item.id)

    if (!this.followStage && !this.isShowStage) {
      this.$message.error('请补全相关信息')
      return
    }
    if ( !this.followContent) {
      this.$message.error('请补全相关信息')
      return
    }
    const obj = {
      idList: arr,
      stage: this.followStage,
      content: this.followContent,
    }

    await setMarketClueFollow(obj)
    this.$message.success('批量回访成功')
    this.$nextTick(() => {
      this.getTableData()
      this.followStage = ''
      this.followContent = ''
      this.editFollowDialogShow = false
      this.isShowStage = false
    })
  }

  txtClassFun(row) {
    let cla = ''
    if (row.followStatus === '已超时') { //已超时
      cla = 'red-txt'
    }
    return cla
  }




  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }
  pageSizeChange(val: number) {
    this.pageSize = val
    this.getTableData()
  }

  // 表格选中情况发生改变时
  handleSelectionChange(arr: any) {
    this.checkTableList = arr
    this.innerWidth = window.innerWidth
    // 移动端适配
    if(this.innerWidth < 751 && this.checkTableList.length > 0) {
      this.showButton = true
    }
  }
  clearShowButton() {
    this.showButton = false
    this.checkTableList = [];
    (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
  }
  // 跳转线索详情页
  seeClue(id: string, status: number) {
    if (!menuBtn(14)) return
    const win = window.open(window.location.origin + this.$route.matched[0].path + '/marketSeeClue?id=' + id + '&status=' + status, "_blank")
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }
  // 编辑
  clickEdit(row) {
    const win = window.open(`${window.location.origin + this.$route.matched[0].path}/marketNewClue?id=${row.id}&status=${row.status}`, '_blank')
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }

  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '/'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
  // 时间区间过滤器
  changeTime1(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
  // 获取表头
  async getMarketClueHeader() {
    this.loading = true
    const data: any = await gettHeaderByType(0)
    this.draggableList = data.headerUserList
    this.marketTableHead = JSON.parse(JSON.stringify(data.headerUserList))
    this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
    // this.tableKey = Math.random()
    this.getTableData()
  }

  // 获取表格数据
  async getTableData() {
    this.loading = true

    this.checkTableList = []
    const obj = {
      name: this.filterClueName,
      source: this.sourceNameList,
      directorUserId: this.filterDuty,
      createUserId: this.filterCreatePeople,
      createdAt: this.changeTime(this.filterCreateTime as Date[]),
      wechat: this.filterWechat,
      status: this.filterStatus,
      receiverUserId: this.filterButtPeople,
      isSign: this.filterContract as number,
      receiverAt: this.changeTime(this.filterLssueTime as Date[]),
      signAt: this.changeTime1(this.filtersignAt as Date[]),
      sourceType: this.filterSource,
      grade: this.filterGrade,
      direction: this.filterDirection,
      // degree: this.filterDegree,
      eduTemandList: this.filterEduTemandList,
      level2Scourse: this.filterLevel2Scourse,
      level2DepartmentId: this.filterLevel2DepartmentId,
      intentionality: this.filterIntentionality,
      customerUserRealName: this.customerUserRealName,
      departmentIdList: this.departmentIdList,
      receiverLevel2DepartmentId: this.filterReceiverLevel2Department,
      attendSchool: this.filterAttendSchool,
      level: this.filterLevel,
      isPublic: this.isPublic,
      followStatus: this.followStatus,
      remark: this.remark,
      reason: this.reason,
      stage: this.stage,
      isFromPractice: this.isFromPractice,
      phone: this.phone,
      equipment : this.equipment,
      page: this.page,
      limit: this.pageSize,
    }
    const data: any = await getMarketClue(delNullProperty(obj))
    this.tableData = data.marketClueList
    this.total = data.allNum

    this.$nextTick(() => {
      if (this.$refs.multipleTable) {
        if (this.$refs.multipleTable) {
          (this.$refs.multipleTable as HTMLFormElement).doLayout();
          (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        }
      }
    });
    this.loading = false

  }
  changeTable() {
    const newArr = []
    this.draggableListChange.forEach(item => {
      if (item.isShow === true) {
        newArr.push(item)
      }
    })
    if (newArr.length == 1) {
      newArr.forEach(item => {
        item.isDisBtn = true
      })
    } else {
      newArr.forEach(item => {
        item.isDisBtn = false
      })
    }
  }
  // 改变表头顺序
  async draggableEnd() {
    this.draggableList = this.draggableListChange
    const newArr: object = this.draggableList.filter(item =>
        item.isShow === true
    )
    if ((newArr as []).length > 0) {
      await settHeaderByType({headerIds: this.draggableList, types: 0})
      this.$message.success('修改表头顺序成功')
      this.getMarketClueHeader()
      this.tableHeadPopoverShow = false
      // this.tableKey = Math.random()
    } else {
      this.$message.error('至少保留一个表头')
    }
  }

  // 取消调整表头
  doCancel() {
    this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
    this.tableHeadPopoverShow = false
  }
  // 获取线索来源列表
  async getMarketClueSourceList() {
    const data: any = await getMarketClueSourceList(delNullProperty(
        {
          page: this.sourcePage,
          limit: this.sourceLimit,
          source: this.source
        })
    )
    this.filterSourceNameList = data.marketClueSourceList

  }

  async handleClueSource() {
    if ((this.filterSourceNameList.length == 0 || !this.source) && !this.filterSourceName) {
      this.source = null
      this.sourcePage = 1

      const result: any = await getMarketClueSourceList(delNullProperty(
          {
            page: this.sourcePage,
            limit: this.sourceLimit,
            source: this.source
          })
      )

      this.filterSourceNameList = result.marketClueSourceList

    }


  }

  handleClueSourceBlur() {
    this.source = null
    this.sourcePage = null
    this.sourceLimit = null
    this.getMarketClueSourceList()
  }

  async remoteMethod(query: any) {

    this.source = query
    this.sourcePage = 1
    this.sourceLimit = 20
    if (query !== '') {
      const result: any = await getMarketClueSourceList(delNullProperty({
        page: this.sourcePage,
        limit: this.sourceLimit,
        source: query
      }))
      this.filterSourceNameList = result.marketClueSourceList
      this.$forceUpdate()

    } else {
        this.filterSourceNameList = []
    }
  }


  loadmore() {
    this.sourcePage = 1
    this.sourceLimit += 20
    this.getMarketClueSourceList();
  }


  clearClueSource() {
    this.filterSourceName = ''
    this.source = null
    this.sourcePage = 1
    this.sourceLimit = 20
    this.getMarketClueSourceList()
  }

  changeClueSource(val) {
    this.sourceNameList = val
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = 1
      this.getTableData()
    }, 1000)
  }

  // 批量下发
  closeIssueDialogVisible() {
    this.receiverUser = ''
    this.issueDialogShow = false;
    (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
    this.checkTableList = []
  }

  openBatchdialog() {
    this.issueDialogShow = true
    this.disBtn = false
  }

  async confirmIssueDialogVisible() {
    if (!this.receiverUser) {
      this.$message.error('请选择下发人');
        return
    }
    this.disBtn = true
    const arr = this.checkTableList.map(item => item.id)
    await setMarketClueStatusReceiver({
      idList: arr,
      status: 1,
      receiverUserId: this.receiverUser
    }).then(() => {
      this.issueDialogShow = false
      this.$message.success('线索下发成功')
      this.disBtn = false
    }).catch(() => {
      this.issueDialogShow = false
      this.disBtn = false
    })

    this.checkTableList = [];
    // (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
    this.receiverUser = ''

    this.getTableData()
  }

  // 收回线索
  clickTakeClue(item: any) {
    this.takeBackClueDialog = true
    this.takeBackClueID = item.id
  }
  async confirmTalkBackClue() {
    await setMarketClueStatusReceiver({
      idList: [this.takeBackClueID],
      status: 0,
    })
    this.takeBackClueDialog = false
    this.takeBackClueID = undefined
    this.getTableData()
  }

  // 批量标为无效
  clickInvalid(row: any) {
    this.markInvalidDialogShow = true
    this.aloneInvaildId = row.id
  }
  closeMarkInvalidDialogVisible() {
    this.markInvalidDialogShow = false
  }
  async confirmMarkInvalidDialogVisible() {
    if(!this.cause){
      this.$message.error('无效原因不可为空！')
      return
    }
    const arr: number[] = this.checkTableList.map(item => item.id)
    await setMarketClueStatusInvalid({
      idList: this.aloneInvaildId ? [this.aloneInvaildId] : arr,
      status: 4,
      reason: this.cause,
    })
    this.$message.success('数据已标为无效')
    this.checkTableList = [];
    this.markInvalidDialogShow = false
    this.getTableData()
    this.cause = ''
  }

  // 批量修改负责人
  closeEditUpPersonDialogVisible() {
    this.editUpPersonDialogShow = false
    this.checkTableList = [];
    (this.$refs.multipleTable as HTMLFormElement).clearSelection();
  }
  async confirmEditUpPersonDialogVisible() {
    const arr = this.checkTableList.map(item => item.id)
    await setMarketClueUser({
      idList: arr,
      types: 0,
      userId: this.receiverUser
    })
    this.$message.success('修改下发人成功')
    this.checkTableList = [];
    this.receiverUser = '';
    // (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
    this.getTableData()
    this.editUpPersonDialogShow = false

  }

  // 批量修改来源
  closeEditSourceDialogVisible() {
    this.editSourceDialogShow = false
    this.checkTableList = [];
    (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
    this.editSource = ''
    this.editSourceType = undefined

  }
  async confirmEditSourceDialogVisible() {
    const arr = this.checkTableList.map(item => item.id)
    if (!this.editSourceType && String(this.editSourceType) !== '0') {
      this.$message.error('请选择来源');
        return
    }
    await setMarketClueUser({
      idList: arr,
      types: 1,
      sourceType: this.editSourceType as number, //来源
      source: this.editSource //具体来源
    })
    this.$message.success('修改来源成功')
    this.checkTableList = [];
    // (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
    this.getTableData()
    this.editSourceDialogShow = false
    this.editSource = ''
    this.editSourceType = undefined
  }

  // 批量修改负责人
  closeEditDutyDialogVisible() {
    this.editDutyDialogShow = false
    this.checkTableList = [];
    (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
  }
  async confirmEditDutyDialogVisible() {
    const arr = this.checkTableList.map(item => item.id)
    await setMarketClueUser({
      idList: arr,
      types: 2,
      userId: this.receiverUser,
    })
    this.$message.success('修改负责人成功')
    this.checkTableList = [];
    this.receiverUser = '';
    // (this.$refs.multipleTable as HTMLFormElement).clearSelection(); // 清除选中的 table-row
    this.getTableData()
    this.editDutyDialogShow = false
  }

  // 导出数据
  getMarketClueExportData(keys: string = '') {
    this.exportButtonDisabled = true
    getMarketClueExportData(delNullProperty({
      name: this.filterClueName,
      source: this.sourceNameList,
      directorUserId: this.filterDuty,
      createUserId: this.filterCreatePeople,
      createdAt: this.changeTime(this.filterCreateTime as Date[]),
      wechat: this.filterWechat,
      status: this.filterStatus,
      receiverUserId: this.filterButtPeople,
      isSign: this.filterContract as number,
      receiverAt: this.changeTime(this.filterLssueTime as Date[]),
      signAt: this.changeTime1(this.filtersignAt as Date[]),
      sourceType: this.filterSource,
      grade: this.filterGrade,
      direction: this.filterDirection,
      eduTemandList: this.filterEduTemandList,
      level2Scourse: this.filterLevel2Scourse,
      level2DepartmentId: this.filterLevel2DepartmentId,
      intentionality: this.filterIntentionality,
      customerUserRealName: this.customerUserRealName,
      departmentIdList: this.departmentIdList,
      receiverLevel2DepartmentId: this.filterReceiverLevel2Department,
      attendSchool: this.filterAttendSchool,
      isPublic: this.isPublic,
      level: this.filterLevel,
      followStatus: this.followStatus,
      remark: this.remark,
      reason: this.reason,
      stage: this.stage,
      isFromPractice: this.isFromPractice,
      phone: this.phone,
      equipment: this.equipment,
      keys,
    })).then(() => {
      this.exportButtonDisabled = false
      this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    }).catch(() => {
      this.exportButtonDisabled = false
    })
  }
  clickCluesStatisticsData() {
    window.open(window.location.origin + this.$route.matched[0].path + '/marketCluesStatisticsData', '_blank')
  }

  //跟进统计报表
  openStatic() {
    window.open(window.location.origin + this.$route.matched[0].path + '/marketFollow', '_blank')
  }



  // 新建线索
  clickNewBuilt() {
    const win = window.open(`${window.location.origin + this.$route.matched[0].path}/marketNewClue`, '_blank')
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }

  // 单条下发
  clickAloneIssue(row) {
    this.aloneDialogTable.push(row)
    this.aloneIssueDialog = true
    this.buttonDisabled = false
  }
  closeAloneIssueDialog() {
    this.aloneIssueDialog = false
    this.aloneDialogTable = []
  }
  confirmAloneIssueDialog() {
    this.buttonDisabled = true
    const arr: number[] = this.aloneDialogTable.map(item => item.id)
    setMarketClueStatusReceiver({
      idList: arr,
      status: 1,
      receiverUserId: this.receiverUser
    })
    .then(res => {
      this.aloneIssueDialog = false
      this.$message.success('线索下发成功')
      this.aloneDialogTable = []
      this.receiverUser = ''
      this.getTableData()
    })
        .catch(err => {
          // if(err.toString().indexOf('Network Error')!==-1||err.toString().indexOf('timeout of 120000ms exceeded')!==-1||err.toString().indexOf('Request failed with status code 500')!==-1){
          // 只要有报错就更改按钮为可点击状态
          this.buttonDisabled = false
          // }
        })
  }

  // 单条修改下发人
  clickAloneEditIssue(row) {
    this.aloneDialogTable.push(row)
    this.editAloneIssueDialog = true
  }
  closeEditAloneIssueDialog() {
    this.aloneDialogTable = []
    this.editAloneIssueDialog = false
  }
  async confirmEditAloneIssueDialog() {
    const arr: number[] = this.aloneDialogTable.map(item => item.id)
    await setMarketClueUser({
      idList: arr,
      types: 0,
      userId: this.receiverUser
    }).then(()=>{
      this.getTableData()
      this.$message.success('下发人修改成功')
      this.aloneDialogTable = []
      this.editAloneIssueDialog = false
      this.receiverUser = ''
    }).catch(err=>{
      this.aloneDialogTable = []
      this.editAloneIssueDialog = false
      this.receiverUser = ''
    })
  }

  // 单条标为无效、激活
  clickAloneInvaild(row) {
    this.aloneInvaildId = row.id
    this.aloneInvaildDialog = true
  }
  closeAloneInvaildDialog() {
    this.aloneInvaildDialog = false
    this.aloneInvaildId = undefined
  }
  async confirmAloneInvaildDialog() {
    if(!this.cause){
      this.$message.error('无效原因不可为空！')
      return
    }
    await setMarketClueStatusInvalid({
      idList: [this.aloneInvaildId],
      status: 4,
      reason: this.cause,
    })
    this.getTableData()
    this.$message.success('线索已标为无效')
    this.aloneInvaildId = undefined
    this.aloneInvaildDialog = false
    this.cause = ''
  }
  async clickActivation(item: any) {
    await setMarketClueStatusInvalid({
      idList: [item.id],
      status: 0,
    })
    this.$message.success('线索激活成功')
    this.getTableData()

  }

  // 修改来源时，来源类别发生改变时
  async sourceTypeChange(val: number) {
    if (val === 1) {
      const data: any = await getMarketChannelType()
      this.sourceChildList = data.marketChannelTypeList
    }
    if (val === 0) {
      this.marketLevelPage = 1
      this.marketLevelSize = 20
      this.getMarketCooperationPrevLevel()
    }
    if (val === 3) {
      const data: any = await getMarketHighSchoolBranchCenterList('3')
      this.collegesList = data.marketHighSchoolBranchCenterList
    }
    if (val === 4) {
      const data: any = await getMarketHighSchoolBranchCenterList('4')
      this.branchedPassageList = data.marketHighSchoolBranchCenterList
    }
    this.editSource = ''
  }

  // 批量修改来源具体来源名称
  changeCooperativePartner(val) {
    this.editSource = val
  }

  clearCooperativePartner() {
    this.cooperativePartnerList= []
    this.editSource = ''
    this.cooperativePartnerName = null
    this.marketLevelPage = 1
    this.marketLevelSize = 20
    this.getMarketCooperationPrevLevel()
  }

  cooperativePartnerLoadmore() {
    this.marketLevelPage = 1
    this.marketLevelSize += 20
    this.getMarketCooperationPrevLevel();
  }

  async getMarketCooperationPrevLevel() {
    const data: any = await getMarketCooperationPrevLevel(
        {
          page: this.marketLevelPage,
          name: this.cooperativePartnerName,
          limit: this.marketLevelSize
        }
    )
    this.cooperativePartnerList = [...this.cooperativePartnerList, ...data.marketCooperationList]
  }


  async remoteCooperativePartnerMethod(query: any) {
    this.cooperativePartnerName = query
    this.marketLevelPage = 1
    this.marketLevelSize = 20
    if (query !== '') {
      const result: any = await getMarketCooperationPrevLevel({
        page: this.marketLevelPage,
        limit:this.marketLevelSize,
        name: query
      })
      this.cooperativePartnerList = result.marketCooperationList
    }
  }

  async cascaderLazyload(node: any, reslove: any) {
    if (node.level === 0) { reslove(); return }
    const data: any = await getMarketChannelNameByTypeId(node.value)
    let nodes: any[] = []
    nodes = data.marketChanneNamelList.map((item: any) => ({
      id: item.id,
      name: item.name,
      leaf: node.level >= 1
    }))
    reslove(nodes)
  }
  changeSourceName() {
    const node = (this.$refs['cascader'] as HTMLFormElement).getCheckedNodes()[0]
    this.editSource = node.label
  }

  // 查看客户详情
  clickCustomer(row) {
    if(!menuBtn(14)) return
    window.open(window.location.origin + this.$route.matched[0].path + '/maketClueCusmoterInfo?id=' + row.id, "_blank")
  }

  // 初始化socket
  // initSocket() {
  //   const time = setInterval(() => {
  //     if(Vue.prototype.$socket.on) {
  //         realTimeSokcet(this.userId, 'CustomerConversion', this.getTableData)
  //         clearInterval(time)
  //     }
  // }, 100)
  // }

  // 所属部门筛选
  chooseDepartment(checkedKeys){
    const tree = this.$refs.tree as HTMLFormElement
    const arr = []
    tree.forEach(item => {
      arr.push(item.getCheckedKeys())
    })
    function flatter(arr) {
      //此代码的意思是接受一个数组作为参数
      const newArr = [];  // 这个空数组用于处理扁平化之后的数组元素
      function fn(date) {  //如果date是一个数组就需要对date经行遍历
        for (let i = 0; i < date.length; i++) {
          const tem = date[i];  // 使用tem储存每一个数组的元素
          if (Array.isArray(tem)) { //表示如果tem是一个数组，则执行下面的函数
            fn(tem)  //调用fn函数，并传入一个实参
          } else {
            newArr.push(tem);//此代码的意思是，如果不是一个数组就把每个元素push到newArr 这个数组中
          }
        }
      }

      fn(arr) //表示调用上面的fn函数，并且传入一个实参arr
      return newArr //表示返回这个结果，讲这个结果返回给这个函数的调用者
    }

    const p = flatter(arr) //表示返回这个结果，并且赋值给p

    this.departmentIdList = p
  }

  treeChange(item: any, itembol: boolean) {
    // console.log('item',item)
  }

  async getDeparment() {
    const data: any = await getDeparmentList()
    this.deparmentList = data
  }


  changefilterDuty(e) {
    this.filterDuty = e.id
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = 1
      this.getTableData()
    }, 1000)
  }

  changefilterCreatePeople(e) {
    this.filterCreatePeople = e.id
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = 1
      this.getTableData()
    }, 1000)
  }

  changefilterButtPeople(e) {
    this.filterButtPeople = e.id
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = 1
      this.getTableData()
    }, 1000)
  }

  changeReceiverUser(e){
    this.receiverUser = e.id
  }

  // @Watch('userId')
  // handleWatchUserId() {
  //   this.initSocket()
  // }

  /*回放记录统计报表*/
  openFollowUpStatic(){
    window.open(window.location.origin + this.$route.matched[0].path + '/marketFollowStatic', '_blank')
  }
}
